// const env = "dev";

export const serverUrl = () => {
  if(window.location.hostname === "localhost"){
    return "http://localhost:8080/adviso/api";
  }else{
    return "https://www.adviso.it/api";
  }
};